import Vue from 'vue';
import Vuex from 'vuex';
import headTitle from './head-title';

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		headTitle
	}
});

export default store;



// WEBPACK FOOTER //
// ./main/store/index.js